import React, { Component, Fragment } from 'react';
import * as ReactSpark from "react-spark";
const { Type, Link } = ReactSpark;
import config from '../../../config';
import './CommunicationConsent.scss';

class CommunicationConsent extends Component {
    render() {
        const baseUrl = config.webUIRoot;

        return (
            <Fragment>
                <Type.BodyFour>
                    <strong>Communication Consent:</strong>
                </Type.BodyFour>
                <Type.BodyFour>
                    By submitting your contact information you agree to our{' '}
                    <Link
                        className="communication-consent__link"
                        href='https://rocketaccount.com/#/privacy-policy/'
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Privacy Policy
                    </Link>
                    {' '}and{' '}
                    <Link
                        className="communication-consent__link"
                        href={`${baseUrl}/terms-of-use`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Terms of Use
                    </Link>
                    . You also expressly consent to receive sales, marketing, and other calls and texts, 
                    including those sent by any automated system or other means for selecting and dialing 
                    telephone numbers, or using an artificial or prerecorded voice message when a 
                    connection is completed, from Rocket Loans at the telephone number you have provided, 
                    even if that telephone number is on a do-not-call list. Agreement to receive such calls
                    or messages is not a condition of purchasing goods or services from us or Cross River 
                    Bank, as applicable. You acknowledge that you provided us your cellular number during a 
                    transaction that, if consummated, will result in you owing a debt to Cross River Bank,
                    a New Jersey-state chartered bank, Member FDIC. Please refer to the{' '}
                    <Link
                        className="communication-consent__link"
                        href={`${baseUrl}/terms-of-use`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Terms of Use
                    </Link>
                    {' '}for how to opt out of receiving marketing information.
                </Type.BodyFour>
                <br />
            </Fragment>
        );
    }
}

export default CommunicationConsent;
